import { createSlice } from "@reduxjs/toolkit";

import { ExecutorGroup } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, ExecutorGroup.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateExecutorGroupData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.EXECUTOR_GROUP_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateExecutorGroupDataAction =
	globalStateExecutorGroupData.actions;
export const globalStateExecutorGroupDataReducer =
	globalStateExecutorGroupData.reducer;
export type globalStateExecutorGroupDataState = State;

export default globalStateExecutorGroupData;
